<template>
  <transition name="intake" mode="out-in">
    <div :key="phrase.id">
      <h1 
        :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
        class="h1 mt0 mb0">{{ phrase.headline }}</h1>
      <p v-if="phrase.sub_headline" class="p small c-mid mb-">
        {{ phrase.sub_headline }}
      </p>
    </div>
  </transition>
</template>


<script>

// Vuex
import { mapGetters } from 'vuex';


export default {
  name: 'text-carousel',
  props: {
    phrase: Object,
  },

  computed: {
    ...mapGetters('app', ['org']),
  },


};
</script>



// WEBPACK FOOTER //
// TextCarousel.vue?3860a334